
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M271 50l.173.003.137.006.1.008.087.007a5.774 5.774 0 01.487.073l.137.03c.12.027.238.058.354.094l.089.029a4.185 4.185 0 01.352.13l.025.01.159.07.08.039.107.053.088.046.078.044a4.765 4.765 0 01.832.589l.078.07.033.03-.009-.009.01.01.061.057.03.028 75 73 .008.008.009.009a5.043 5.043 0 01.58.681l.052.075.066.101c.022.032.042.064.062.097l.055.094a2.752 2.752 0 01.107.191l.05.097c.095.192.178.39.249.593l.027.08.037.119.024.083c.033.117.061.234.086.354l.014.075c.01.05.019.101.026.152l.01.067a3.554 3.554 0 01.037.345l.006.103c.003.047.005.096.006.145v.064l.001.05v242c0 8.284-6.716 15-15 15H105c-8.284 0-15-6.716-15-15V65c0-8.18 6.547-14.83 14.686-15H271zm-5 10H105a5 5 0 00-5 5v305a5 5 0 005 5h231a5 5 0 005-5V133h-60c-8.284 0-15-6.716-15-15V60zM126 280h189a5 5 0 01.217 9.995L315 290H126a5 5 0 01-.217-9.995L126 280h189zm189-36a5 5 0 01.217 9.995L315 254H126a5 5 0 01-.217-9.995L126 244h189zm0-36a5 5 0 01.217 9.995L315 218H126a5 5 0 01-.217-9.995L126 208h189zm-90.603-36a5 5 0 110 10H126a5 5 0 110-10zM276 66.844V118a5 5 0 005 5h52.695L276 66.844zm-1.665-15.569l.052.047-.024-.021-.028-.026zm-3.178-1.273l.028.001h-.012l-.016-.001zm-.095-.002l.062.002h.029L271 50h.062z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    